module.exports = __webpack_public_path__ + "static/media/inquiry_history_black.1c8b24e5.svg";